import { render, staticRenderFns } from "./safetyDisclosure.vue?vue&type=template&id=4cc31fba&scoped=true"
import script from "./safetyDisclosure.vue?vue&type=script&lang=js"
export * from "./safetyDisclosure.vue?vue&type=script&lang=js"
import style0 from "./safetyDisclosure.vue?vue&type=style&index=0&id=4cc31fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc31fba",
  null
  
)

export default component.exports